import { gql } from '@apollo/client';

export const SUBREGION_CARRIER_FIELDS = gql`
    fragment SubregionCarrierFields on subregion_carrier_mappings {
        carrier_id
        warehouse_carrier_id
        is_direct
        is_primary
        mapping_id
        middle_mile_carrier_id
        subregion_id
        warehouse_id
        site_code
        site_contact_name
        site_contact_email
        site_contact_phone
    }
`;
